const URL = "https://hamro-dairy-api.onrender.com/api/"
module.exports = URL